import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { handleShowProfile } from "../auth/Auth";         // adjust path as needed
import { updateUser } from "../../store/slice/user";       // adjust path as needed

const useLocationMissing = () => {
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.user);
  const [locationMissing, setLocationMissing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // No token = not logged in -> no location required
    if (!authToken) {
      setLocationMissing(false);
      setIsLoading(false);
      return;
    }

    const checkLocation = async () => {
      setIsLoading(true);
      try {
        // Always fetch the latest profile from the server
        const profile = await handleShowProfile(authToken);
        if (!profile) throw new Error("Failed to load profile");

        // Keep Redux and localStorage in sync
        dispatch(updateUser(profile));
        localStorage.setItem("user", JSON.stringify(profile));

        // Determine which address array to inspect
        const addresses = profile.is_chef
          ? profile.chef_addresses
          : profile.user_addresses;

        // Get the last saved address entry
        const last = addresses?.length > 0 ? addresses[addresses.length - 1] : null;

        // Check if the address is missing, "NA", or missing coordinates
        const invalid =
          !last ||
          !last.address ||
          last.address === "NA" ||
          last.address.toLowerCase() === "null" ||
          !last.latitude ||
          !last.longitude;

        setLocationMissing(invalid);
      } catch (error) {
        // If we can't verify, assume the location is missing to be safe
        setLocationMissing(true);
      } finally {
        setIsLoading(false);
      }
    };

    checkLocation();
  }, [authToken, dispatch]);   // runs whenever authToken changes (e.g., login/logout)

  return { locationMissing, isLoading };
};

export default useLocationMissing;